// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/boost/components/GuildBoostLevelBadge.module.css';
import {boostLevelBadgeUrl} from '@app/features/boost/utils/BoosterBadge';

export const GuildBoostLevelBadge = ({level, size}: {level: number; size: 16 | 20 | 24}) => {
	const src = boostLevelBadgeUrl(level);
	if (!src) return null;
	return (
		<img
			src={src}
			alt=""
			width={size}
			height={size}
			className={styles.badge}
			draggable={false}
			data-boost-level={level}
			data-flx="boost.level-badge"
		/>
	);
};
